module.exports = __webpack_public_path__ + "b0ebc7dda90a79d3331b80e977b3f27f.png";